export const APP_NAME = "LedgerFlow";

export const categories = [
  { value: "Food & Dining", text: "Food & Dining", color: "#2563eb", icon: "k-i-cart" },
  { value: "Transportation", text: "Transportation", color: "#0f766e", icon: "k-i-map-marker" },
  { value: "Housing", text: "Housing", color: "#7c3aed", icon: "k-i-home" },
  { value: "Shopping", text: "Shopping", color: "#c2410c", icon: "k-i-bag" },
  { value: "Entertainment", text: "Entertainment", color: "#db2777", icon: "k-i-star" },
  { value: "Healthcare", text: "Healthcare", color: "#16a34a", icon: "k-i-heart" },
  { value: "Other", text: "Other", color: "#64748b", icon: "k-i-folder" }
];

export const categoryNames = categories.map((category) => category.value);

export const normalizeCategory = (value) => {
  const text = String(value || "").trim();
  const lowerText = text.toLowerCase();
  const exactMatch = categoryNames.find((category) => category.toLowerCase() === lowerText);

  if (exactMatch) return exactMatch;
  if (lowerText.includes("food") || lowerText.includes("dining")) return "Food & Dining";
  if (lowerText.includes("transport") || lowerText.includes("car")) return "Transportation";
  if (lowerText.includes("housing") || lowerText.includes("rent") || lowerText.includes("home")) return "Housing";
  if (lowerText.includes("shopping")) return "Shopping";
  if (lowerText.includes("entertainment")) return "Entertainment";
  if (lowerText.includes("health")) return "Healthcare";

  return "Other";
};

export const tags = [
  "Essential",
  "Business",
  "Personal",
  "Family",
  "Travel",
  "Subscription",
  "Optional"
];

export const priorities = ["Low", "Medium", "High", "Critical"];

export const frequencies = ["One-time", "Daily", "Weekly", "Monthly", "Yearly"];

export const currencies = [
  { text: "USD", value: "USD" },
  { text: "EUR", value: "EUR" },
  { text: "GBP", value: "GBP" },
  { text: "TRY", value: "TRY" }
];

export const languages = [
  { text: "English", value: "EN" },
  { text: "Russian", value: "RU" },
  { text: "Turkish", value: "TR" }
];

export const fontSizes = [
  { text: "Compact", value: "compact" },
  { text: "Comfortable", value: "comfortable" },
  { text: "Large", value: "large" }
];

export const themeModes = [
  { text: "Auto", value: "auto" },
  { text: "Light", value: "light" },
  { text: "Dark", value: "dark" }
];

export const accentThemes = [
  { text: "Blue", value: "#2563eb" },
  { text: "Teal", value: "#0f766e" },
  { text: "Emerald", value: "#0f8a5f" },
  { text: "Amber", value: "#b7791f" },
  { text: "Rose", value: "#be123c" }
];

export const DEFAULT_EXCHANGE_RATES = {
  USD: 1,
  EUR: 0.92,
  GBP: 0.79,
  TRY: 33.1
};

export const menuItems = [
  { id: "dashboard", text: "Dashboard", icon: "k-i-chart-line" },
  { id: "expenses", text: "Expenses", icon: "k-i-list-unordered" },
  { id: "goals", text: "Goals", icon: "k-i-check-target" },
  { id: "reports", text: "Reports", icon: "k-i-chart-column-clustered" },
  { id: "profile", text: "Profile", icon: "k-i-user" },
  { id: "settings", text: "Settings", icon: "k-i-gear" }
];

export const emptyExpense = {
  title: "",
  amount: null,
  date: new Date(),
  category: categoryNames[0],
  description: "",
  tags: [],
  frequency: "One-time",
  priority: "Medium",
  receiptName: "",
  receiptDataUrl: "",
  receiptType: ""
};

export const emptyGoal = {
  title: "",
  targetAmount: null,
  currentAmount: null,
  targetDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
  description: ""
};

export const emptyFilters = {
  search: "",
  category: "All",
  minAmount: null,
  maxAmount: null,
  startDate: null,
  endDate: null,
  tags: [],
  priority: "All",
  period: "all"
};

export const defaultCategoryBudgets = categoryNames.reduce((budgetMap, category) => {
  budgetMap[category] = 0;
  return budgetMap;
}, {});

export const defaultCategoryOrder = [...categoryNames];
